import { useState } from 'react'

import internalApiQueryWrapper from '../../core/internalApiQueryWrapper'
import useRegion from '../../hooks/useRegion'
import { validateEmail } from './utils/validateEmail'

const configureParams = ({ newsletterList, email, regionName }) => {
  const lists = newsletterList.filter(list => list.checked).reduce((acc, list) => ({ ...acc, [list.name]: 1 }), {})
  return {
    email,
    lists: JSON.stringify(lists),
    regionName: regionName
  }
}

const SignUp = ({ email, newsletterList, setHelperText }) => {
  const [subscriptionMessage, setSubcriptionMessage] = useState('')
  const [messageClassName, setMessageClassName] = useState('')
  const region = useRegion()
  const regionName = region.name

  const signUp = () => {
    if (validateEmail(email)) {
      internalApiQueryWrapper('/api/newsletter/subscribe', configureParams({ newsletterList, email, regionName })).then(
        ({ ok }) => {
          if (ok) {
            setSubcriptionMessage('All set, thanks for signing up!')
            setMessageClassName('subscriptionMessage')
          } else {
            setSubcriptionMessage('Oops, something went wrong')
            setMessageClassName('subscriptionMessage error')
          }
        }
      )
    } else {
      setHelperText('Oops, that email address is invalid!')
    }
  }

  return (
    <div className='signup-container'>
      <button className='signup-button' onClick={signUp}>
        <span className='signup-button-text'>Sign up</span>
      </button>
      {subscriptionMessage && <div className={messageClassName}>{subscriptionMessage}</div>}
    </div>
  )
}

export default SignUp
